import SearchHeader from './searchHeader'

export default SearchHeader
